// Generated by `bazel run i18n`. Do not edit by hand.
import unsubscribe_c826f058 from "./en/src--marketing--unsubscribe.json";
import mobileUpload_adf7aacf from "./en/src--mobile-upload.json";
import order_9b6d226e from "./en/src--order.json";
import return_e3a35c3c from "./en/src--return.json";
import withdrawal_c46cd62c from "./en/src--withdrawal.json";

export default Object.assign(
  {},
  unsubscribe_c826f058,
  mobileUpload_adf7aacf,
  order_9b6d226e,
  return_e3a35c3c,
  withdrawal_c46cd62c,
);
